<template>
	<div class="wrapper auth-wrapper">
		<ClientOnly>
			<div class="auth-body">
				<AuthSidebar />
				<div class="auth-content">
					<slot/>
				</div>
			</div>
			<template #fallback>
				<UiLoader class="spacing" />
			</template>	
		</ClientOnly>
	</div>
</template>

<script setup>

</script>

<style scoped lang="less">
	.auth-wrapper{
		padding: 40px 0;
		@media (max-width: @t){padding: 20px 0;}
	}
	.auth-body{
		display: flex; gap: 60px;
		@media (max-width: @t){display: block;}
	}
	.auth-content{
		flex-grow: 1;
		@media (max-width: @t){display: flex; flex-direction: column;}
	}
	:deep(.auth-main-title){
		font-size: 28px;
		@media (max-width: @m){font-size: 24px;}
	}
</style>